import React from 'react';

interface MobileSectionTitleProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
}

const MobileSectionTitle: React.FC<MobileSectionTitleProps> = ({
  title,
  subtitle,
  centered = false,
}) => {
  return (
    <div className={`mb-6 ${centered ? 'text-center' : ''}`}>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">
        {title}
      </h2>
      {subtitle && (
        <p className="text-sm text-gray-600">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default MobileSectionTitle;
